/**
 * ProtectedRoute - Route wrapper that requires authentication
 *
 * CRITICAL FIX (FASE-1 MVP):
 * - Uses `initialized` instead of `loading` to prevent premature redirects
 * - Shows FullPageLoader while auth state is being verified
 * - Only redirects to /auth once initialization is complete and user is null
 *
 * Flow:
 * 1. App mounts → getCurrentUser() runs → initialized=false
 * 2. While !initialized → Show FullPageLoader (verifying session)
 * 3. Once initialized=true:
 *    - If user exists → Render protected content
 *    - If user is null → Redirect to /auth
 *
 * This prevents the bug where refreshing on /my-artworks would redirect to /profile
 * because the component rendered before auth initialization completed.
 *
 * @see docs/refactor-framework/post-refactor-mvp/MVP-ROADMAP.md (FASE-1)
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import FullPageLoader from '../common/FullPageLoader';

const ProtectedRoute = ({ children }) => {
  const { user, initialized } = useSelector(state => state.auth);
  const location = useLocation();

  // Wait for auth initialization to complete
  if (!initialized) {
    return <FullPageLoader message="Verificando sesión..." />;
  }

  // Once initialized, check if user exists
  if (!user) {
    // Redirect to auth page with return url
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // User is authenticated - render protected content
  return children;
};

export default ProtectedRoute;